var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { summarizeType, summarizeWithType, } from "@domains/utils/summarizeWithType";
export var advanceDeclineQouteStream = function (data, streaming) {
    return data === null || data === void 0 ? void 0 : data.map(function (x) {
        if ((x === null || x === void 0 ? void 0 : x.sym) === (streaming === null || streaming === void 0 ? void 0 : streaming.symbol)) {
            return __assign(__assign({}, x), { a: streaming.high, d: streaming.low });
        }
        return x;
    });
};
export var QuotesOverviewStream = function (data, streaming) {
    var _a;
    return (_a = data === null || data === void 0 ? void 0 : data.syLst) === null || _a === void 0 ? void 0 : _a.map(function (x) {
        if ((x === null || x === void 0 ? void 0 : x.symbol) === (streaming === null || streaming === void 0 ? void 0 : streaming.symbol)) {
            return __assign(__assign({}, x), { change: streaming.changePrice, changePercentage: streaming.changePercentage, lastTradedPrice: streaming.curPrice, high: x.high < streaming.high ? streaming.high : x.high, low: x.low > streaming.low ? streaming.low : x.low, 
                // status: streaming.marketStatus,
                lastUpdatedTime: streaming === null || streaming === void 0 ? void 0 : streaming.updatedTime });
        }
    });
};
export var QuotesOptionsOverviewStream = function (data, streaming) {
    var _a, _b, _c, _d;
    // Check if the symbol matches in the main symbol
    if (((_a = data === null || data === void 0 ? void 0 : data.qt) === null || _a === void 0 ? void 0 : _a.sym) === (streaming === null || streaming === void 0 ? void 0 : streaming.symbol)) {
        return __assign(__assign({}, data), { qt: __assign(__assign({}, data === null || data === void 0 ? void 0 : data.qt), { h: (data === null || data === void 0 ? void 0 : data.qt.h) < streaming.high ? streaming.high : data.qt.h, l: (data === null || data === void 0 ? void 0 : data.qt.l) > streaming.low ? streaming.low : data.qt.l, ltp: streaming.curPrice, chg: streaming.changePrice, chgP: streaming.changePercentage, vol: streaming.volume, atp: streaming.avgTradedPrice, updatedTime: streaming.updatedTime, rlOvrCstPrc: streaming.rollOverCost, rlOvrCst: streaming.rollOver, rlOvrP: streaming.rollOverCostPercentage, opInt: summarizeWithType(streaming.openInterest, summarizeType.LAKHS, false).toString(), opIntChgP: streaming.oiChangePercentage, ltpivfut: streaming.iv }), futExp: (_b = data === null || data === void 0 ? void 0 : data.futExp) === null || _b === void 0 ? void 0 : _b.map(function (item) {
                if ((item === null || item === void 0 ? void 0 : item.sym) === (streaming === null || streaming === void 0 ? void 0 : streaming.symbol)) {
                    return __assign({}, item);
                }
                return item;
            }) });
    }
    // Check if the symbol matches in the spot symbol
    if (((_c = data === null || data === void 0 ? void 0 : data.qt) === null || _c === void 0 ? void 0 : _c.spotSym) === (streaming === null || streaming === void 0 ? void 0 : streaming.symbol)) {
        return __assign(__assign({}, data), { qt: __assign(__assign({}, data.qt), { spot: streaming.curPrice, spotChg: streaming.changePrice, spotChgP: streaming.changePercentage }) });
    }
    // Update items in the futExp array if the symbol matches
    var updatedFutExp = (_d = data === null || data === void 0 ? void 0 : data.futExp) === null || _d === void 0 ? void 0 : _d.map(function (item) {
        if ((item === null || item === void 0 ? void 0 : item.sym) === (streaming === null || streaming === void 0 ? void 0 : streaming.symbol)) {
            return __assign({}, item);
        }
        return item; // Return unmodified item if the symbol does not match
    });
    // Return the updated data with the modified futExp array
    return __assign(__assign({}, data), { futExp: updatedFutExp });
};
export var IndicesQuotesConstituent = function (data, streaming) {
    return data.map(function (x) {
        if ((x === null || x === void 0 ? void 0 : x.sym) === (streaming === null || streaming === void 0 ? void 0 : streaming.symbol)) {
            return __assign(__assign({}, x), { chg: streaming.changePrice, chgP: streaming.changePercentage, ltp: streaming.curPrice });
        }
        return x;
    });
};
export var futureQuotesPeerCompanies = function (data, streaming) {
    return data.map(function (item) {
        var _a;
        item.futExp = (_a = item.futExp) === null || _a === void 0 ? void 0 : _a.map(function (x) {
            if ((x === null || x === void 0 ? void 0 : x.sym) === (streaming === null || streaming === void 0 ? void 0 : streaming.symbol)) {
                return __assign(__assign({}, x), { ltp: streaming.curPrice, chg: streaming.changePrice, chgP: streaming.changePercentage });
            }
            return x;
        });
        return item;
    });
};
export var IndiesEtfData = function (data, streaming) {
    return data.map(function (x) {
        if ((x === null || x === void 0 ? void 0 : x.nseToken) === (streaming === null || streaming === void 0 ? void 0 : streaming.symbol)) {
            return __assign(__assign({}, x), { chg: streaming.changePrice, chgP: streaming.changePercentage, ltp: streaming.curPrice });
        }
        return x;
    });
};
